import { defineComponent as _defineComponent } from 'vue'
import { PropType, computed, ref, Ref } from 'vue'
import { Thumbs } from '@/templates/slplus/structure/questionModels'
import { useI18n } from 'vue-i18n'
import berry from '@/assets/tasks/enig/blueberrie.svg'
import spinach from '@/assets/tasks/enig/spinach.svg'
import mushroom from '@/assets/tasks/enig/mushroom.svg'
import flower from '@/assets/tasks/enig/flower.svg'
import glasses from '@/assets/tasks/enig/glasses2.svg'
import omarHappyGlassesImage from '@/assets/omar/worm-happy-glasses.svg'
import omarYummyImage from '@/assets/omar/worm-yummy.svg'
import right from '@/assets/right_white.svg'
import wrong from '@/assets/wrong_white.svg'

type ImageKey = 0 | 1 | 2 | 3
type Results = {
  [key in ImageKey]: { answer: Thumbs; correct: boolean } | undefined
}

type Images = {
  [key in ImageKey]: string
}

export default /*#__PURE__*/_defineComponent({
  __name: 'QuizzResults',
  props: {
  results: {
    type: Object as PropType<Results>,
    required: true,
  },
  omarWasCorrect: {
    type: Boolean,
    default: false,
  },
},
  setup(__props, { expose }) {
  expose();

const props = __props

const messages = {
  no: {
    correctGuesses: 'Riktig!',
    omarWasRight: 'Omar hadde rett',
    omarWasWrong: 'Omar tok feil',
  },
  en: {
    correctGuesses: 'Correct!',
    omarWasRight: 'Omar was right',
    omarWasWrong: 'Omar was wrong',
  },
}



const agreeImages: Ref<Images> = ref({
  0: berry,
  1: spinach,
  2: mushroom,
  3: flower,
})
const disagreeImages: Ref<Images> = ref({
  0: glasses,
  1: glasses,
  2: glasses,
  3: glasses,
})

const { t } = useI18n({ messages })

const totalCorrect = Object.values(props.results).reduce((a, c) => a + (c?.correct ? 1 : 0), 0)

const answerImages = computed(() =>
  Object.values(props.results)
    .filter((a) => !!a) // Typescript does not observe removal of undefined here!
    .map((a, i) => {
      const index = i as ImageKey
      const agree = a?.answer === Thumbs.up
      if (a) {
        return { src: agree ? agreeImages.value[index] : disagreeImages.value[index], correctSrc: a.correct ? right : wrong, correct: a.correct }
      }
    }),
)

const __returned__ = { messages, props, agreeImages, disagreeImages, t, totalCorrect, answerImages, omarHappyGlassesImage, omarYummyImage }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})